import { Component, computed, signal } from '@angular/core';
import { SaveActionButtonBase } from '../_save-button-base/save-button-base';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'save-and-return-button',
    templateUrl: './save-and-return-button.component.html',
    styleUrl: './save-and-return-button.component.scss',
    imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule],
})
export class SaveAndReturnButtonComponent extends SaveActionButtonBase
{
    saveButtonText = computed(() => {
        return this.saving()
            ? 'Saving your application'
            : 'Save & Return';
    })

    cancelButtonText = signal('Cancel & Return');

    constructor() {
        super();
        this.loadConfig('saveAndReturnConfig.json');
    }

    cancelAndReturn() {
        window.location.href = this.currentConfig.data['returnUrl'];
    }

    saveAndReturn() {
        this.saveApplication()
            .subscribe({
                next: (result) => {
                    if (result == true) {
                        this.redirect();
                    }
                }
            });
    }

    redirect() {
        let url = this.currentConfig.data['returnUrl'] ??
                  this.currentConfig.data['defaultUrl'];

        if (url) {
            window.location.href = url;
        }
    }
}
